import actions from "./actions";
import mutations from "./mutations";
import getters from "./getters";

const state = {
  appProduct: {
    id: "",
    name: "",
    subTitle: [],
    baRefConstructeur: "",
    thumbnail: "",
    legend: {
      name: "",
      dimensions: {},
      shortDescription: [],
      type: "",
    },
    technicalCharacteristics: {
      picto_image: "",
    },
    description: "",
    gallery: {
      images: [],
      pictos: [],
      productId: "",
      brandImage: "",
      energyLabel: {},
    },
    videos: [],
    shippingMethods: {},
    notice: 3.36,
    noticeCount: 21,
    flashSell: {
      startFlashSell: "",
      endFlashSell: "",
    },
    productsRelated: {},
    shippingInfo: {
      existAlso: {},
      available: true,
      displayStockAvailability: true,
      prices: [],
      hasPromo: false,
    },
    billInfo: {
      ecoTaxe: 0,
      tva: 0,
      originalTva: 0,
      originalPrice: 0,
      specialPrice: undefined,
      finalPrice: 0,
      schedule: {},
      currentShippingMethodPrice: {
        specialPrice: 0,
        originalPrice: 0
      }
    },
    tempPrice: 0,
    options: {},
    essentialsOptions: {},
    canAddToComparator: false,
    isInComparator: false,
    isTaxReducible: false,
    selectedDelivery: "",
    reducedTaxRate: {},
    productBlocks: {},
    productStrates: {},
    productInstallation: {},
    productReviews: [],
    productReviewsAverage: {
      rate: 0,
      count: 0,
    },
    priceInfo: "",
    productEncodedUrl: {},
    socialMediaShare: [],
    hasZblockDelivery: false,
    hasZblockInstallation: false,
    zblocksDeliveryId: false,
    zblocksInstallationId: false,
    zblocksHowToChooseId: false,
    zblocksFindOutMoreId: false,
    cartUrl: "",
    getCategoryId: "",
    configQuestions: {
      "q1": {
        "label": "Vous êtes : ",
        "reset": [
          "individual",
          "co_ownership",
          "at-work"
        ],
        "answers": [
          /*{
            "id": "individual",
            "label_1": "Individuel",
            "label_2": "En maison individuelle",
            "label_3": "TVA à 5.5%",
            "label_3_class": "label_3_green",
            "scroll-to": "individual",
            "update-cart": "1",
            "image": "images/checkout/icon-individual.svg",
            "to-send": {
              "customer_tax_class_id": 3,
              "product_tax_class_id": 5
            }
          },
          {
            "id": "co_ownership",
            "label_1": "Co-Ownership",
            "label_2": "En copropriété",
            "label_3": "TVA à 5.5%",
            "label_3_class": "btn--border-blue",
            "label_3_bubble_info": "lorem ipsum",
            "scroll-to": "co_ownership",
            "update-cart": "1",
            "image": "images/checkout/copro.svg",
            "to-send": {
              "customer_tax_class_id": 3,
              "product_tax_class_id": 5
            }
          },
          {
            "id": "at_work",
            "label_1": "Professional",
            "label_2": "En entreprise",
            "label_3": "TVA à 20% + <span class=\"bonus\">ADVENIR bonus</span>",
            "label_3_class": "label_3_green",
            "label_3_bubble_info": "lorem ipsum",
            "scroll-to": "at_work",
            "update-cart": "1",
            "image": "images/checkout/professional.svg",
            "to-send": {
              "customer_tax_class_id": 6,
              "product_tax_class_id": 2
            }
          }*/
        ]
      },
      "q2": {
        "at_work": {
          "label": "In a professional building, where do you want to install your charging point?",
          "dependencies": [
            "at-work"
          ],
          "reset": [
            "individual",
            "co_ownership"
          ],
          "answers": [
            /*{
              "id": "electric_charger_installation_work_parking_spot",
              "label_1": "Indoor, on my parking spot",
              "label_1_class": "txt-left",
              "label_2": "15 mètres maximum",
              "label_2_bubble_info": "Si la distance entre votre point de recharge et le tableau électrique est supérieur à 15 mètres, sélectionnez à la prochaine étape \"Option\", les câbles d'alimentation (vendu par 5 mètres).",
              "update-cart": "1",
              "image": "images/checkout/compteur-bureau-15m-place.svg",
              "to-send": {
                "mpl_link_key": "electric_charger_installation_work_parking_spot"
              }
            },
            {
              "id": "electric_charger_installation_work_closed_box",
              "label_1": "Outside, on my parking space",
              "label_1_class": "txt-left",
              "label_2": "15 mètres maximum",
              "label_2_bubble_info": "Si la distance entre votre point de recharge et le tableau électrique est supérieur à 15 mètres, sélectionnez à la prochaine étape \"Option\", les câbles d'alimentation (vendu par 5 mètres).",
              "update-cart": "1",
              "image": "images/checkout/compteur-exterieur-15m.svg",
              "to-send": {
                "mpl_link_key": "electric_charger_installation_work_closed_box"
              }
            },
            {
              "id": "work_other_case",
              "label_1": "Other case",
              "label_1_class": "txt-left",
              "label_2": "My project does not match any of the above.",
              "label_2_bubble_info": "Si votre projet est plus complexe ou nécessite l'installation de plusieurs points de recharge : prenez rendez-vous gratuitement avec votre électricien <a href='#'> en cliquant ici</a>",
              "disable-form": "1",
              "image": "images/checkout/compteur-bureau-autres.svg"
            }*/
          ]
        },
        "co_ownership": {
          "label": "In your condominium, where would you like to install your charging point?",
          "dependencies": [
            "co-ownership"
          ],
          "reset": [
            "individual",
            "at_work"
          ],
          "answers": [
            /*{
              "id": "electric_charger_installation_home_parking_spot",
              "label_1": "Indoor, on my parking spot",
              "label_1_class": "txt-left",
              "label_2": "5 mètres",
              "label_2_bubble_info": "lorem ipsum",
              "update-cart": "1",
              "image": "images/checkout/compteur-copro-15m-place.svg",
              "to-send": {
                "mpl_link_key": "electric_charger_installation_home_parking_spot"
              }
            },
            {
              "id": "electric_charger_installation_home_closed_box",
              "label_1": "Indoor, in my closed box",
              "label_1_class": "txt-left",
              "label_2": "5 mètres",
              "label_2_bubble_info": "lorem ipsum",
              "update-cart": "1",
              "image": "images/checkout/compteur-copro-15m-box.svg",
              "to-send": {
                "mpl_link_key": "electric_charger_installation_home_closed_box"
              }
            },
            {
              "id": "home_other_case",
              "label_1": "Other case",
              "label_1_class": "txt-left",
              "label_2": "My project does not match any of the above.",
              "label_2_bubble_info": "lorem ipsum",
              "disable-form": "1",
              "image": "images/checkout/compteur-autres.svg"
            }*/
          ]
        },
        "individual": {
          "label": "Où souhaitez-vous installer votre point de recharge ?",
          "reset": [
            "co_ownership",
            "at_work"
          ],
          "answers": [
            /*{
              "id": "electric_charger_installation_home_same_room_less_5m",
              "label_1": "In the same room as my electrical panel",
              "label_1_class": "txt-left",
              "label_2": "5 mètres",
              "update-cart": "1",
              "image": "images/checkout/compteur-interieur-5m.svg",
              "to-send": {
                "mpl_link_key": "electric_charger_installation_home_same_room_less_5m"
              }
            },
            {
              "id": "electric_charger_installation_home_other_room_less_15m",
              "label_1": "In a room different from that of my electrical panel",
              "label_1_class": "txt-left",
              "label_2": "15 mètres",
              "update-cart": "1",
              "image": "images/checkout/compteur-interieur-15m-piece.svg",
              "to-send": {
                "mpl_link_key": "electric_charger_installation_home_other_room_less_15m"
              }
            },
            {
              "id": "electric_charger_installation_home_outside",
              "label_1": "Outside, on the front",
              "label_1_class": "txt-left",
              "label_2": "15 mètres",
              "update-cart": "1",
              "image": "images/checkout/compteur-exterieur-15m.svg",
              "to-send": {
                "mpl_link_key": "electric_charger_installation_home_outside"
              }
            },
            {
              "id": "home_other",
              "label_1": "Other case",
              "label_1_class": "txt-left",
              "label_2": "My project does not match any of the above.",
              "label_2_bubble_info": "lorem ipsum",
              "disable-form": "1",
              "image": "images/checkout/compteur-autres.svg"
            }*/
          ]
        }
      }
    },
    renting_price: {},
    financing_price: {},
    renting_related_products: [],
    lead_type: "",
  },
  is_rentable: "",
  is_financeable: "",
  is_retailable: "",
  is_lead: false,
  is_pac: false,
  pac_type: null,
  is_RFID_card: false,
  mcp_universe: "",
  mcp_extended_warranty: "",
  additionalProduct: [],
  months_renting: 0,
  rate_tax_delivery_classic: 5.5,
  tva_profils: {
    low_rate: 0,
    medium_rate: 0,
    high_rate: 0
  },
  breadcrumbs: [],
  is_accessory_product: false,
  mcp_slots_choice_active: true,
  mcp_form_strapi_id: false
};

export default {
  state,
  mutations,
  getters,
  actions,
};
